/**
 * PATH: apps/quote/src/pages/builder/builder-workspace/builder-helpers.ts
 * PURPOSE: Shared helpers for BuilderWorkspaceEditor and BuilderEditor
 */

/** Parse string/number/null/undefined to a number (0 fallback) */
export function toNumber(value: string | number | null | undefined): number {
  if (typeof value === 'number') return value
  if (typeof value === 'string') {
    const n = Number.parseFloat(value)
    return Number.isFinite(n) ? n : 0
  }
  return 0
}

/** Tailwind class string for margin badge based on percentage */
export function getMarginColor(margin: number): string {
  if (margin >= 30) return 'text-emerald-700 bg-emerald-50 border-emerald-200 dark:bg-emerald-900/20 dark:border-emerald-800 dark:text-emerald-300'
  if (margin >= 25) return 'text-green-700 bg-green-50 border-green-200 dark:bg-green-900/20 dark:border-green-800 dark:text-green-300'
  if (margin >= 20) return 'text-lime-700 bg-lime-50 border-lime-200 dark:bg-lime-900/20 dark:border-lime-800 dark:text-lime-300'
  if (margin >= 15) return 'text-amber-700 bg-amber-50 border-amber-200 dark:bg-amber-900/20 dark:border-amber-800 dark:text-amber-300'
  if (margin >= 10) return 'text-orange-700 bg-orange-50 border-orange-200 dark:bg-orange-900/20 dark:border-orange-800 dark:text-orange-300'
  return 'text-red-700 bg-red-50 border-red-200 dark:bg-red-900/20 dark:border-red-800 dark:text-red-300'
}

/** Map quote status to badge class */
export function statusBadgeClass(status: string): string {
  const map: Record<string, string> = {
    draft: 'bg-slate-500 text-white',
    pending_approval: 'bg-amber-500 text-white',
    approved: 'bg-blue-500 text-white',
    sent: 'bg-violet-500 text-white',
    accepted: 'bg-emerald-500 text-white',
    rejected: 'bg-red-500 text-white',
    expired: 'bg-slate-400 text-white',
  }
  return map[status] || 'bg-slate-500 text-white'
}

/** Format a number as currency */
export function formatNumber(value: number, decimals = 0): string {
  return value.toFixed(decimals)
}

/** Grid column definition - 18 columns matching Excel structure */
export const GRID_COLS = 'grid-cols-[32px_80px_1fr_120px_60px_45px_55px_45px_45px_60px_60px_85px_85px_75px_75px_50px_85px_28px]'

/** Debounce window for section creation */
export const SECTION_CREATION_DEBOUNCE_MS = 1000
